export default "__VITE_ASSET__DGQGM_MJ__"